import React, { useState } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { ChevronIcon } from "@cars24/turbo-web/lib/icons/chevron-icon";
import CheckIcon from "@cars24/turbo-web/lib/icons/check-icon";
import { Label } from "@cars24/turbo-web/lib/label";
import LazyImage from "../../shared/lazy-image";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { sendCustomGaEvents } from "../../../tracking";
import { pdiQualityCheckClicked } from "../../../constants/tracking-constants/pre-delivery-inspection";

const PreDeliveryInspectionCarDetails = ({ details }) => {

    const {
        subSections: ownershipList = [],
        subTitle: ownershipDescription = "",
        title: ownershipSubTitle = ""
    } = details || {};

    const { tokens } = useTokens();
    const [selectedCategory, setSelectedCategory] = useState(ownershipList[0]);

    const handleSetCategory = async (category, index) => {
        setSelectedCategory(category);
        await yieldToMain();
        sendCustomGaEvents({...pdiQualityCheckClicked, eventLabel: index });
    };

    return (
        <div styleName={"styles.preDeliveryInspectionCarDetails"}>
            <div styleName={"styles.carDetailsWrapper"}>
                <Heading level={2} fontWeight="semibold" color={tokens.text_default_text_primary}>
                    <span>{ownershipSubTitle}</span>{" "}{ownershipDescription}
                </Heading>
                <div styleName={"styles.desktopInspectionContainer"}>
                    <div styleName={"styles.categoryMenu"}>
                        {ownershipList.map((category, index) => (
                            <div
                                key={index}
                                styleName={`${"styles.categoryItem"} ${selectedCategory.title === category.title ? "styles.active" : ""}`}
                                onClick={() => handleSetCategory(category, index)}
                            >
                                <div styleName="styles.categoryTitle">
                                    <LazyImage src={category.image.url} height={24} width={24} alt="category-title" />
                                    <Label level={4} fontWeight="medium" color={selectedCategory.title === category.title ? tokens.text_brand_text_brand : tokens.text_default_text_primary}>
                                        {category.title}
                                    </Label>
                                </div>
                                <ChevronIcon rotateBy={270} size={20} fill={selectedCategory.title === category.title ? tokens.text_brand_text_brand : tokens.text_default_text_primary} />
                            </div>
                        ))}
                    </div>
                    <div styleName={"styles.categoryContent"}>
                        <div styleName={"styles.categoryContentTitle"}>
                            <div styleName={"styles.categoryContentTitleImage"}>
                                <LazyImage src={selectedCategory.image.url} height={24} width={24} alt="category-content" />
                            </div>
                            <Label level={4} fontWeight="semibold" color={tokens.text_default_text_primary}>
                                {selectedCategory.title}
                            </Label>
                        </div>
                        <ul>
                            {selectedCategory.sectionData?.map((item, index) => (
                                <li key={index}>
                                    <CheckIcon size="16px" fill={tokens.background_fill_state_fill_success} />
                                    <Label level={4} fontWeight="regular" color={tokens.text_default_text_primary}>
                                        {item.title}
                                    </Label>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

PreDeliveryInspectionCarDetails.propTypes = {
    details: PropTypes.object
};

export default PreDeliveryInspectionCarDetails;
